import { Chip, Tooltip } from "@mui/material";
import { StyledTableCell } from "../style";
import styled from "styled-components";

const SpacedChip = styled(Chip)`
  margin-inline-end: 0.5rem;
  margin-block-end: 0.5rem;
`;

export default function Tags(args) {
  if (!args.content || !args.content.length)
    return <StyledTableCell {...args} />;

  const shown = args.content.slice(0, 5);
  const extra = args.content.length - shown.length;

  return (
    <StyledTableCell {...args}>
      {shown.map((tag, index) => (
        <Tooltip title={tag} key={index}>
          <SpacedChip label={tag} size="small" />
        </Tooltip>
      ))}
      {extra > 0 && (
        <Tooltip title={args.content.slice(5).join(", ")}>
          <SpacedChip label={`+${extra}`} size="small" variant="outlined" />
        </Tooltip>
      )}
    </StyledTableCell>
  );
}
